import type { MapLocation } from '@/entities/dashboard';
import { LucideIcon } from 'lucide-react';

interface LocationTypeSectionProps {
  title: string;
  icon: LucideIcon;
  iconColor: string;
  locations: MapLocation[];
  formatNumber: (num: number) => string;
  dataField: 'weight' | 'consignments' | 'volume';
  dataSuffix: string;
}

export function LocationTypeSection({
  title,
  icon: Icon,
  iconColor,
  locations,
  formatNumber,
  dataField,
  dataSuffix
}: LocationTypeSectionProps) {
  return (
    <div>
      <h4 className="font-medium mb-3 flex items-center gap-2">
        <Icon className={`w-4 h-4 ${iconColor}`} />
        {title} ({locations.length})
      </h4>
      <div className="space-y-2">
        {locations.map((location) => (
          <div key={location.id} className="text-sm">
            <div className="font-medium">{location.name}</div>
            <div className="text-muted-foreground">
              {location.data[dataField]
                ? `${formatNumber(location.data[dataField] as number)} ${dataSuffix}`
                : 'No data'}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
